// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.vSZC0stGA02tMNn2vPrl {
    padding-left: 1rem;
}

.u1lBFO0s5Uja5_pe7Frm {
    color: var(--color-primary-black);
    text-decoration: underline;
}

.inline-notification--info,
.inline-notification-info {
    display: flex !important;
    flex-direction: row !important;
    align-items: flex-start !important;
    padding: 0.75rem 1rem !important;
    border-radius: 8px;
    background-color: #f0f7ff !important;
    line-height: 1.45 !important;

    --icon-size: 18px;
    --icon-gap: 0.5rem;
    --icon-adjust: 16px;
}

.inline-notification--info svg,
.inline-notification-info svg {
    width: var(--icon-size) !important;
    height: var(--icon-size) !important;
    margin-right: var(--icon-gap) !important;
    margin-top: 0.15rem !important;
    flex-shrink: 0;
}

.inline-notification--info [data-testid="requestedAttributesNotification"],
.inline-notification-info [data-testid="requestedAttributesNotification"] {
    display: block !important;
    margin: 0 !important;
    margin-left: calc(-1 * (var(--icon-size) + var(--icon-gap) + var(--icon-adjust))) !important;
}

.inline-notification--info [data-testid="requestedAttributesNotification"] > span:first-child,
.inline-notification-info [data-testid="requestedAttributesNotification"] > span:first-child {
    display: block !important;
    margin-top: 0 !important;
    text-indent: calc(var(--icon-size) + var(--icon-gap) + var(--icon-adjust)) !important;
}

.inline-notification--info [data-testid="requestedAttributesNotification"] > ul + span,
.inline-notification-info [data-testid="requestedAttributesNotification"] > ul + span {
    display: block !important;
    margin-top: 0.5rem;
    text-indent: 0 !important;
}

@media screen and (max-width: 768px) {
    .inline-notification--info,
    .inline-notification-info {
        padding: 0.6rem 0.8rem !important;
        --icon-size: 16px;
        --icon-gap: 0.4rem;
        --icon-adjust: 16px;
    }
}`, "",{"version":3,"sources":["webpack://./src/features/auth/components/RequestedAttributesNotification/RequestedAttributesNotification.module.css"],"names":[],"mappings":"AAAA;IACI,kBAAkB;AACtB;;AAEA;IACI,iCAAiC;IACjC,0BAA0B;AAC9B;;AAEA;;IAEI,wBAAwB;IACxB,8BAA8B;IAC9B,kCAAkC;IAClC,gCAAgC;IAChC,kBAAkB;IAClB,oCAAoC;IACpC,4BAA4B;;IAE5B,iBAAiB;IACjB,kBAAkB;IAClB,mBAAmB;AACvB;;AAEA;;IAEI,kCAAkC;IAClC,mCAAmC;IACnC,wCAAwC;IACxC,8BAA8B;IAC9B,cAAc;AAClB;;AAEA;;IAEI,yBAAyB;IACzB,oBAAoB;IACpB,4FAA4F;AAChG;;AAEA;;IAEI,yBAAyB;IACzB,wBAAwB;IACxB,qFAAqF;AACzF;;AAEA;;IAEI,yBAAyB;IACzB,kBAAkB;IAClB,yBAAyB;AAC7B;;AAEA;IACI;;QAEI,iCAAiC;QACjC,iBAAiB;QACjB,kBAAkB;QAClB,mBAAmB;IACvB;AACJ","sourcesContent":[".list {\n    padding-left: 1rem;\n}\n\n.link {\n    color: var(--color-primary-black);\n    text-decoration: underline;\n}\n\n:global(.inline-notification--info),\n:global(.inline-notification-info) {\n    display: flex !important;\n    flex-direction: row !important;\n    align-items: flex-start !important;\n    padding: 0.75rem 1rem !important;\n    border-radius: 8px;\n    background-color: #f0f7ff !important;\n    line-height: 1.45 !important;\n\n    --icon-size: 18px;\n    --icon-gap: 0.5rem;\n    --icon-adjust: 16px;\n}\n\n:global(.inline-notification--info svg),\n:global(.inline-notification-info svg) {\n    width: var(--icon-size) !important;\n    height: var(--icon-size) !important;\n    margin-right: var(--icon-gap) !important;\n    margin-top: 0.15rem !important;\n    flex-shrink: 0;\n}\n\n:global(.inline-notification--info [data-testid=\"requestedAttributesNotification\"]),\n:global(.inline-notification-info [data-testid=\"requestedAttributesNotification\"]) {\n    display: block !important;\n    margin: 0 !important;\n    margin-left: calc(-1 * (var(--icon-size) + var(--icon-gap) + var(--icon-adjust))) !important;\n}\n\n:global(.inline-notification--info [data-testid=\"requestedAttributesNotification\"] > span:first-child),\n:global(.inline-notification-info [data-testid=\"requestedAttributesNotification\"] > span:first-child) {\n    display: block !important;\n    margin-top: 0 !important;\n    text-indent: calc(var(--icon-size) + var(--icon-gap) + var(--icon-adjust)) !important;\n}\n\n:global(.inline-notification--info [data-testid=\"requestedAttributesNotification\"] > ul + span),\n:global(.inline-notification-info [data-testid=\"requestedAttributesNotification\"] > ul + span) {\n    display: block !important;\n    margin-top: 0.5rem;\n    text-indent: 0 !important;\n}\n\n@media screen and (max-width: 768px) {\n    :global(.inline-notification--info),\n    :global(.inline-notification-info) {\n        padding: 0.6rem 0.8rem !important;\n        --icon-size: 16px;\n        --icon-gap: 0.4rem;\n        --icon-adjust: 16px;\n    }\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"list": `vSZC0stGA02tMNn2vPrl`,
	"link": `u1lBFO0s5Uja5_pe7Frm`
};
module.exports = ___CSS_LOADER_EXPORT___;
